<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardDeleteApplyList.push"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>
    <v-column-time value="申请时间"/>
    <v-column-avatar label="申请者" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="150"
      align="center"
      prop="add_store_name"
    />
    <el-table-column label="课卡 ID" width="150" align="center" prop="card_id"/>
    <el-table-column label="课卡名称" width="150" align="center" prop="card_name"/>
    <el-table-column
      v-if="isAdministrator"
      label="课卡所属门店"
      width="150"
      align="center"
      prop="store_name"
    />
    <el-table-column label="退款金额" width="150" align="center">
      <template v-slot="{ row }">
        <span>{{ row.del_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="退款原因" width="300" align="center" prop="del_remark"/>
    <el-table-column label="审核状态" width="150" align="center">
      <template v-slot="{ row }">
        <span
          v-for="applyState in findApplyState(row.apply_state)"
          :class="`${applyState.tagType}-color`"
          :key="`applyStateValue${applyState.value}`"
        >
          {{ applyState.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="RouteConfig.cardDeleteApplyDetail.to(row.id)"
        />

        <template v-if="row.update_state === applyStates.review.value">
          <v-list-button
            v-if="isAdministrator"
            name="驳回"
            icon="reject"
            @click="handleReject(row)"
            :is-loading="isRejectingIds.includes(row.id)"
            :is-last="true"
            message="确定要驳回申请吗？"
          />

          <v-list-button
            v-else
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            :is-last="true"
            message="确定要撤销申请吗？"
          />
        </template>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请人员</span>
              <span>{{ v.admin_nickname }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改原因</span>
              <span>{{ v.update_remark }}</span>
            </div>
            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="applyState in findApplyState(v.update_state)"
                :class="`${applyState.tagType}-color`"
                :key="`applyStateValue${applyState.value}`"
              >
                {{ applyState.name }}
              </span>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :to="RouteConfig.cardDeleteApplyDetail.to(v.id)"
              />

              <template v-if="v.update_state === applyStates.review.value">
                <v-list-button
                  v-if="isAdministrator"
                  name="驳回"
                  icon="reject"
                  @click="handleReject(v)"
                  :is-loading="isRejectingIds.includes(v.id)"
                  :is-last="true"
                  message="确定要驳回申请吗？"
                />

                <v-list-button
                  v-else
                  name="撤销"
                  icon="restore"
                  @click="handleRevoke(v)"
                  :is-loading="isRevokingIds.includes(v.id)"
                  :is-last="true"
                  message="确定要撤销申请吗？"
                />
              </template>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { mapGetters } from 'vuex';
import { index, update, destroy } from '@/api/card-del-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.cardDeleteApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      update_state: applyStates.review.value,
      update_remark: '',
      store: {},
      administrator: {},
      student: {},
      old_student: {},
      card_name: '',
      card_type_name: '',
      card_number: '',
      is_generic: 0,
      is_number_limit: 0,
      is_private: 0,
      expire_number: 0,
      expire_days: 0,
      expire_time: 0,
      actual_payment: 0,
      card_payment_mode_name: '',
      payment_remark: '',
      old_card_name: '',
      old_card_type_name: '',
      old_card_number: '',
      old_is_generic: 0,
      old_is_number_limit: 0,
      old_is_private: 0,
      old_expire_number: 0,
      old_expire_days: 0,
      old_expire_time: 0,
      old_actual_payment: 0,
      old_card_payment_mode_name: '',
      old_payment_remark: '',
    },
    applyStates,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  methods: {
    findApplyState,
    refresh() {
      RouteConfig.cardDeleteApplyList.push(this.queryList);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRevoke({ id }) {
      this.isRevokingIds.push(id);
      const { isError } = await destroy(id);
      removeArrayItem(this.isRevokingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
    async handleReject({ id }) {
      this.isRejectingIds.push(id);
      const { isError } = await update(id);
      removeArrayItem(this.isRejectingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
